import { useEffect } from "react";
import { useRouteError } from "react-router";
import { reportError } from "./report.js";

/** A page that failed to draw: say so plainly, offer a reload, and report it (§18). */
export function RouteError() {
  const error = useRouteError();
  useEffect(() => reportError(error), [error]);
  return (
    <div className="bp-page">
      <div className="card bp-pad bp-polite" role="alert">
        <p>Something went wrong showing this page.</p>
        <button type="button" className="btn" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    </div>
  );
}
